import { h, Fragment } from 'preact'
import { HomeScreen } from './HomeScreen.jsx'
import { AiScreen } from './AiScreen.jsx'
import { GuideScreen } from './GuideScreen.jsx'
import { ArticleReaderScreen } from './ArticleReaderScreen.jsx'
import { EmailScreen } from './EmailScreen.jsx'
import { ConversationsScreen } from './ConversationsScreen.jsx'
import { EmailThreadScreen } from './EmailThreadScreen.jsx'
import { t } from '../beacon-i18n.js'

function screenHeaders() {
  return {
    home:          { title: t('support.beacon.header.home.title'), subtitle: t('support.beacon.header.home.subtitle') },
    ai:            { title: t('support.beacon.header.ai.title'), subtitle: null },
    guide:         { title: t('support.beacon.header.guide.title'), subtitle: null },
    email:         { title: t('support.beacon.header.email.title'), subtitle: null },
    conversations: { title: t('support.beacon.header.conversations.title'), subtitle: null },
    email_thread:  { title: t('support.beacon.header.email_thread.title'), subtitle: null },
  }
}

const SCREEN_COMPONENTS = {
  home:          HomeScreen,
  ai:            AiScreen,
  guide:         GuideScreen,
  email:         EmailScreen,
  conversations: ConversationsScreen,
  email_thread:  EmailThreadScreen,
}

/**
 * BeaconPanel — the widget panel shell.
 *
 * Every screen except `guide_article` shares the purple gradient header
 * (+ back arrow when not on `home`) and the constant X close icon in the
 * top-right corner (see plan "Cikkolvasó" section — the article reader
 * draws its own white header instead).
 */
export function BeaconPanel({ store }) {
  const screen = store.screen.value
  const isCompactViewport = store.isCompactViewport.value
  const isArticle = screen === 'guide_article'
  const panelSizeClass = isCompactViewport
    ? 'beacon-panel-fullscreen'
    : `beacon-panel-size-${store.panelSize.value}`

  const ScreenComponent = SCREEN_COMPONENTS[screen] || HomeScreen
  const headers = screenHeaders()
  const header = headers[screen] || headers.home

  return (
    <div class={`beacon-panel ${panelSizeClass} ${isArticle ? 'beacon-panel-article' : ''}`}>
      {isArticle ? (
        <ArticleReaderScreen store={store} />
      ) : (
        <Fragment>
          <div class="beacon-header">
            <div class="beacon-header-top">
              {screen !== 'home' && (
                <button type="button" class="beacon-back-btn" aria-label={t('support.beacon.back_aria_label')} onClick={() => store.goBack()}>
                  <i class="bi bi-arrow-left"></i>
                </button>
              )}
              <h2 class="beacon-header-title">{header.title}</h2>
              <button type="button" class="beacon-close-btn" aria-label={t('support.beacon.close_aria_label')} onClick={() => store.close()}>
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            {header.subtitle && <p class="beacon-header-subtitle">{header.subtitle}</p>}
          </div>

          <div key={screen} class={`beacon-screen-body beacon-screen-anim-${store.navDirection.value}`}>
            <ScreenComponent store={store} />
          </div>
        </Fragment>
      )}
    </div>
  )
}
